// react
import React, { useMemo, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

// third-party
import { Helmet } from "react-helmet-async";

// application
import shopApi from "../../api/shop";
import { useDeferredData, useProductColumns, useProductTabs } from "../../services/hooks";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// blocks
import BlockBanner from "../blocks/BlockBanner";
import BlockBrands from "../blocks/BlockBrands";
import BlockCategories from "../blocks/BlockCategories";
import BlockFeatures from "../blocks/BlockFeatures";
import BlockPosts from "../blocks/BlockPosts";
import BlockProductColumns from "../blocks/BlockProductColumns";
import BlockProducts from "../blocks/BlockProducts";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import BlockSlideShow from "../blocks/BlockSlideShow";

// data stubs
import { categories } from "../../data/shopBlockCategories";
import theme from "../../data/theme";

function HomePageOne(props) {
    const { locale } = props;

    // State pour stocker les produits
    const [featuredProducts, setFeaturedProducts] = useState({ isLoading: true, data: [] });
    const [bestsellers, setBestsellers] = useState({ isLoading: true, data: [] });
    const [latestProducts, setLatestProducts] = useState({ isLoading: true, data: [] });


    

    // Charger les produits vedettes (featured products)
    useEffect(() => {
        const fetchFeaturedProducts = async () => {
            setFeaturedProducts({ isLoading: true, data: [] });
            const response = await shopApi.getFeaturedProducts({ limit: 8, category: undefined }, locale);
            setFeaturedProducts({ isLoading: false, data: response.products || [] });
        };
        fetchFeaturedProducts();
    }, [locale]); // Remettre à jour lorsque `locale` change



    // Charger les bestsellers
    useEffect(() => {
        const fetchBestsellers = async () => {
            setBestsellers({ isLoading: true, data: [] });
            const response = await shopApi.geBestsellersProducts({ limit: 7 }, locale);
            setBestsellers({ isLoading: false, data: response.products || [] });
        };

        fetchBestsellers();
    }, [locale]); // Remettre à jour lorsque `locale` change

    console.log(featuredProducts, 'featuredProducts');

    // Charger les nouveaux produits (latest products)
    useEffect(() => {
        const fetchLatestProducts = async () => {
            setLatestProducts({ isLoading: true, data: [] });
            const response = await shopApi.getLatestProducts({ limit: 8, category: undefined });
            setLatestProducts({ isLoading: false, data: response.products || [] });
        };

        fetchLatestProducts();
    }, [locale]);
    /**
     * Product columns.
     */
    // const columns = useProductColumns(
    //     useMemo(() => [
    //         {
    //             title: 'Top Rated Products',
    //             source: () => shopApi.getTopRatedProducts({ limit: 3 }),
    //         },
    //         {
    //             title: 'Special Offers',
    //             source: () => shopApi.getDiscountedProducts({ limit: 3 }),
    //         },
    //         {
    //             title: 'Bestsellers',
    //             source: () => shopApi.getPopularProducts({ limit: 3 }),
    //         },
    //     ], []),
    // );

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Home Page — ${theme.name}`}</title>
            </Helmet>

            {useMemo(
                () => (
                    <BlockSlideShow withDepartments />
                ),
                []
            )}

            {useMemo(
                () => (
                    <BlockFeatures />
                ),
                []
            )}

            {bestsellers?.data?.length > 0 && (
                <BlockProducts
                    title={<FormattedMessage id="home.bestsellers" />}
                    layout="large-first"
                    featuredProduct={bestsellers.data[0]}
                    products={bestsellers.data.slice(1)}
                />
            )}

            {featuredProducts.data && (
                <BlockProductsCarousel
                    title={<FormattedMessage id="home.featuredProducts" />}
                    layout="grid-4"
                    products={featuredProducts.data}
                    loading={featuredProducts.isLoading}
                />
            )}

            {useMemo(
                () => (
                    <BlockCategories title="Popular Categories" layout="classic" categories={categories} />
                ),
                []
            )}

            {/*           {useMemo(() => (
                <BlockProductsCarousel
                    title="New Arrivals"
                    layout="horizontal"
                    rows={2}
                    products={latestProducts.data}
                    loading={latestProducts.isLoading}
                    groups={latestProducts.tabs}
                    onGroupClick={latestProducts.handleTabChange}
                />
            ), [latestProducts])}

            {useMemo(() => <BlockPosts title="Latest News" layout="list-sm" posts={posts} />, [])}

            {useMemo(() => <BlockBrands />, [])} 

            {useMemo(() => <BlockProductColumns columns={columns} />, [columns])}*/}
        </React.Fragment>
    );
}

HomePageOne.propTypes = {
    /** current locale */
    locale: PropTypes.string,
};
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(HomePageOne);
